require("whatwg-fetch");

if (window.appFunctions === undefined) {
    window.appFunctions = {};
}

window.appFunctions.initializeAutoSuggest = (
    textInputElementId,
    resultAreaElementId,
    apiUri,
    itemOpeningHtml,
    itemClosingHtml,
    dividerHtml,
    itemClass,
    onSuggestionChoosen,
    idNumberOnPage,
) => {
    window["$textInput" + idNumberOnPage] = jQuery("#" + textInputElementId);
    window["$resultArea" + idNumberOnPage] = jQuery("#" + resultAreaElementId);

    window["$resultArea" + idNumberOnPage].hide();

    jQuery("body").on("click", (event) => {
        if (event.originalEvent.target.id !== textInputElementId) {
            window["$resultArea" + idNumberOnPage].hide();
        }
    });

    let fetchInProgress = false;

    let typingTimer;
    const doneTypingInterval = 200;

    window["$textInput" + idNumberOnPage].on("keyup", () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    window["$textInput" + idNumberOnPage].on("keydown", () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    const doneTyping = () => {
        const currentText = window["$textInput" + idNumberOnPage].val();

        if (currentText.length === 0) {
            window["$resultArea" + idNumberOnPage].hide();
        } else {
            if (!fetchInProgress) {
                fetchInProgress = true;

                window
                    .fetch(apiUri + "?q=" + encodeURIComponent(currentText))
                    .then((response) => response.json())
                    .then((results) => {
                        fetchInProgress = false;

                        if (results["bestMatches"].length > 0) {
                            // Schließe das PLZ-Dropdown, falls es geöffnet ist
                            jQuery("#select-zipcode-or-city").hide();

                            window["$resultArea" + idNumberOnPage].empty();

                            let newHtml = "";

                            results["bestMatches"].forEach((item, index) => {
                                if (index === 0) {
                                    newHtml += "<strong>" + itemOpeningHtml + item + itemClosingHtml + "</strong>";
                                } else {
                                    newHtml += itemOpeningHtml + item + itemClosingHtml;
                                }
                            });

                            if (results["additionalMatches"].length > 0) {
                                newHtml += dividerHtml;

                                results["additionalMatches"].forEach((item) => {
                                    newHtml += itemOpeningHtml + item + itemClosingHtml;
                                });
                            }

                            window["$resultArea" + idNumberOnPage].html(newHtml);
                            window["$resultArea" + idNumberOnPage].show();

                            $itemElement = jQuery("." + itemClass);

                            $itemElement.on("click", (event) => {
                                window["$textInput" + idNumberOnPage].val(event.target.firstChild.data);
                                window["$resultArea" + idNumberOnPage].hide();
                                if (typeof onSuggestionChoosen === "function") {
                                    onSuggestionChoosen();
                                }
                            });
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        fetchInProgress = false;
                    });
            }
        }
    };

    console.log("AutoSuggest initialized on #" + textInputElementId);
};
